import styles from "./styles.module.css";
import * as Editors from "../../../editors";
import { useState, useEffect } from "react";
export default function PropInput({ prop, utility, index, onChange, sources }) {
  const Input = Editors[prop.editor];
  const [params, setParams] = useState(prop.editorParams);
  const [_sources, setSources] = useState(sources);

  useEffect(() => {
    if (typeof prop.editorParams !== "object" || !utility.id) return;
    const params = { ...prop.editorParams };
    Object.keys(params).forEach((key) => {
      if (utility.props[params[key]] !== undefined) {
        params[key] = utility.props[params[key]];
      }
    });
    console.log(prop, params);
    setParams(params);
  }, [prop.editorParams, utility]);

  const _onChange = (v) => {
    const _utility = { ...utility };
    _utility.props[prop.name] = v;
    onChange(_utility);
  };

  if (!Input || !params || !prop || !utility.props) {
    return null;
  }
  return (
    <div style={{ zIndex: 300 - index }} className={styles.propInput}>
      <div className={styles.propTitle}>{prop.displayName}</div>
      <Input
        value={utility.props[prop.name]}
        params={params}
        onChange={_onChange}
        sources={_sources}
      />
      <div className={styles.propHelp}>{prop.help}</div>
    </div>
  );
}
